import { render, staticRenderFns } from "./FaceRecord.vue?vue&type=template&id=7eadcee4&scoped=true&"
import script from "./FaceRecord.vue?vue&type=script&lang=js&"
export * from "./FaceRecord.vue?vue&type=script&lang=js&"
import style0 from "./FaceRecord.vue?vue&type=style&index=0&id=7eadcee4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eadcee4",
  null
  
)

export default component.exports